import { Box, makeStyles, Tab as MuiTab, Tabs as MuiTabs, useMediaQuery, useTheme } from "@material-ui/core";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

const useStyles = makeStyles((theme) => ({
  tabsRoot: {
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  indicator: {
    backgroundColor: theme.palette.primary.main,
    height: 3,
    borderTopLeftRadius: 3,
    borderTopRightRadius: 3,
  },
  tabRoot: {
    textTransform: "none",
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(14),
    marginRight: theme.spacing(0.5),
    minWidth: 0,
    minHeight: 48,
    padding: theme.spacing(1, 3),
    color: theme.palette.text.secondary,
    opacity: 1,
    "&:hover": {
      color: theme.palette.text.primary,
    },
    "&$selected": {
      color: theme.palette.primary.main,
      // fontWeight: theme.typography.fontWeightMedium,
    },
    "&:focus": {
      color: theme.palette.primary.main,
    },
    "& .MuiTab-wrapper": {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      gap: theme.spacing(1),
      "& > *:first-child": {
        marginBottom: 0,
        // marginRight: theme.spacing(1), // Add space between icon and label
      },
    },
  },
  selected: {},
  tabPanelRoot: {
    padding: theme.spacing(3, 3),
  },
}));

export const SKTabs = ({ children, className = "", variant, scrollButtons, ...props }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <MuiTabs
      classes={{
        root: `${classes.tabsRoot} ${className}`,
        indicator: classes.indicator,
      }}
      textColor="primary"
      variant={variant !== undefined ? variant : isMobile ? "scrollable" : "standard"}
      scrollButtons={scrollButtons !== undefined ? scrollButtons : isMobile ? "on" : "auto"}
      {...props}
    >
      {children}
    </MuiTabs>
  );
};

export const SKTab = ({ className = "", label, icon, mobileIconOnly = true, ...props }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // If on mobile, has an icon, and mobileIconOnly is true, we hide the label.
  const displayLabel = isMobile && icon && mobileIconOnly ? undefined : label;

  return (
    <MuiTab
      // label={displayLabel}
      label={label}
      icon={icon}
      classes={{
        root: `${classes.tabRoot} ${className}`,
        selected: classes.selected,
      }}
      disableRipple
      {...props}
    />
  );
};

export const SKTabPanel = ({ children, value, index, className = "", disablePadding = false, ...props }) => {
  const classes = useStyles();

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`sk-tabpanel-${index}`}
      aria-labelledby={`sk-tab-${index}`}
      className={className}
      {...props}
    >
      {value === index && <Box className={!disablePadding ? classes.tabPanelRoot : ""}>{children}</Box>}
    </div>
  );
};

export const skTabProps = (index) => {
  return {
    id: `sk-tab-${index}`,
    "aria-controls": `sk-tabpanel-${index}`,
  };
};
